import styled from 'styled-components';
import { DurationForm } from 'modules/workflowNodeEditors/components/formElements/DurationForm';
import { BasicSelect } from 'ui/selects';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const WideSelect = styled(BasicSelect)`
  width: ${pxToRem(300)};
`;

export const DurationFieldsContainer = styled.div`
  display: flex;
  gap: ${spacing.half};
`;

export const StyledDurationForm = styled(DurationForm)`
  width: 50%;
`;
